"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Generated from splitscript/antlr_files/Splitscript.g4 by ANTLR 4.13.1
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
const antlr4_1 = require("antlr4");
class SplitscriptLexer extends antlr4_1.Lexer {
    static LPAREN = 1;
    static RPAREN = 2;
    static TIMES = 3;
    static POW = 4;
    static DIV = 5;
    static PLUS = 6;
    static MINUS = 7;
    static COMPARISON_OPERATIONS = 8;
    static BOOLEAN_OPERATIONS = 9;
    static INT = 10;
    static FLOAT = 11;
    static PERCENTAGE = 12;
    static STRING = 13;
    static BOOL = 14;
    static COLUMN = 15;
    static ARGS_SPLITTER = 16;
    static ID = 17;
    static COMMENTS = 18;
    static WS = 19;
    static EOF = antlr4_1.Token.EOF;
    static channelNames = ["DEFAULT_TOKEN_CHANNEL", "HIDDEN"];
    static literalNames = [null, "'('",
        "')'", "'*'",
        "'^'", "'/'",
        "'+'", "'-'"];
    static symbolicNames = [null, "LPAREN",
        "RPAREN", "TIMES",
        "POW", "DIV",
        "PLUS", "MINUS",
        "COMPARISON_OPERATIONS",
        "BOOLEAN_OPERATIONS",
        "INT", "FLOAT",
        "PERCENTAGE",
        "STRING", "BOOL",
        "COLUMN", "ARGS_SPLITTER",
        "ID", "COMMENTS",
        "WS"];
    static modeNames = ["DEFAULT_MODE",];
    static ruleNames = [
        "STRINGDOUBLE", "STRINGSINGLE", "COLUMN_DELIMITER_START", "COLUMN_DELIMITER_UNDERSCORE",
        "COLUMN_DELIMITER_END", "LPAREN", "RPAREN", "TIMES", "POW", "DIV", "PLUS",
        "MINUS", "COMPARISON_OPERATIONS", "BOOLEAN_OPERATIONS", "INT", "FLOAT",
        "PERCENTAGE", "STRING", "BOOL", "COLUMN", "ARGS_SPLITTER", "ID", "COMMENTS",
        "WS",
    ];
    constructor(input) {
        super(input);
        this._interp = new antlr4_1.LexerATNSimulator(this, SplitscriptLexer._ATN, SplitscriptLexer.DecisionsToDFA, new antlr4_1.PredictionContextCache());
    }
    get grammarFileName() { return "Splitscript.g4"; }
    get literalNames() { return SplitscriptLexer.literalNames; }
    get symbolicNames() { return SplitscriptLexer.symbolicNames; }
    get ruleNames() { return SplitscriptLexer.ruleNames; }
    get serializedATN() { return SplitscriptLexer._serializedATN; }
    get channelNames() { return SplitscriptLexer.channelNames; }
    get modeNames() { return SplitscriptLexer.modeNames; }
    // @Override
    action(localctx, ruleIndex, actionIndex) {
        switch (ruleIndex) {
            case 21:
                this.ID_action(localctx, actionIndex);
                break;
        }
    }
    ID_action(localctx, actionIndex) {
        switch (actionIndex) {
            case 0:
                1;
                break;
        }
    }
    static _serializedATN = [4, 0, 19, 202, 6, -1, 2, 0,
        7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9,
        7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7,
        16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23,
        1, 0, 1, 0, 5, 0, 52, 8, 0, 10, 0, 12, 0, 55, 9, 0, 1, 0, 1, 0, 1, 1, 1, 1, 5, 1, 61, 8, 1, 10, 1, 12,
        1, 64, 9, 1, 1, 1, 1, 1, 1, 2, 1, 2, 1, 3, 1, 3, 1, 3, 1, 4, 1, 4, 1, 5, 1, 5, 1, 6, 1, 6, 1, 7, 1, 7, 1,
        8, 1, 8, 1, 9, 1, 9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 12, 1, 12, 1, 12, 1, 12, 1, 12, 1,
        12, 1, 12, 1, 12, 1, 12, 3, 12, 100, 8, 12, 1, 13, 1, 13, 1, 13, 1, 13, 3, 13, 106, 8, 13, 1, 14,
        4, 14, 109, 8, 14, 11, 14, 12, 14, 110, 1, 15, 4, 15, 114, 8, 15, 11, 15, 12, 15, 115, 1, 15, 1,
        15, 4, 15, 120, 8, 15, 11, 15, 12, 15, 121, 1, 16, 1, 16, 5, 16, 126, 8, 16, 10, 16, 12, 16, 129,
        9, 16, 1, 16, 1, 16, 1, 17, 1, 17, 3, 17, 135, 8, 17, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1,
        18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 3, 18, 155, 8, 18,
        1, 19, 1, 19, 4, 19, 159, 8, 19, 11, 19, 12, 19, 160, 1, 19, 1, 19, 1, 19, 1, 19, 4, 19, 167, 8,
        19, 11, 19, 12, 19, 168, 1, 19, 1, 19, 3, 19, 173, 8, 19, 1, 20, 1, 20, 1, 21, 1, 21, 1, 21, 5, 21,
        180, 8, 21, 10, 21, 12, 21, 183, 9, 21, 1, 22, 1, 22, 1, 22, 1, 22, 5, 22, 189, 8, 22, 10, 22, 12,
        22, 192, 9, 22, 1, 22, 1, 22, 1, 23, 4, 23, 197, 8, 23, 11, 23, 12, 23, 198, 1, 23, 1, 23, 2, 160,
        168, 0, 24, 1, 0, 3, 0, 5, 0, 7, 0, 9, 0, 11, 1, 13, 2, 15, 3, 17, 4, 19, 5, 21, 6, 23, 7, 25, 8, 27,
        9, 29, 10, 31, 11, 33, 12, 35, 13, 37, 14, 39, 15, 41, 16, 43, 17, 45, 18, 47, 19, 1, 0, 8, 1, 0,
        34, 34, 1, 0, 39, 39, 1, 0, 48, 57, 2, 0, 44, 44, 59, 59, 2, 0, 65, 90, 97, 122, 3, 0, 65, 90, 95,
        95, 97, 122, 2, 0, 10, 10, 13, 13, 3, 0, 9, 10, 12, 13, 32, 32, 219, 0, 11, 1, 0, 0, 0, 0, 13, 1,
        0, 0, 0, 0, 15, 1, 0, 0, 0, 0, 17, 1, 0, 0, 0, 0, 19, 1, 0, 0, 0, 0, 21, 1, 0, 0, 0, 0, 23, 1, 0, 0, 0,
        0, 25, 1, 0, 0, 0, 0, 27, 1, 0, 0, 0, 0, 29, 1, 0, 0, 0, 0, 31, 1, 0, 0, 0, 0, 33, 1, 0, 0, 0, 0, 35, 1,
        0, 0, 0, 0, 37, 1, 0, 0, 0, 0, 39, 1, 0, 0, 0, 0, 41, 1, 0, 0, 0, 0, 43, 1, 0, 0, 0, 0, 45, 1, 0, 0, 0,
        0, 47, 1, 0, 0, 0, 1, 49, 1, 0, 0, 0, 3, 58, 1, 0, 0, 0, 5, 67, 1, 0, 0, 0, 7, 69, 1, 0, 0, 0, 9, 72, 1,
        0, 0, 0, 11, 74, 1, 0, 0, 0, 13, 76, 1, 0, 0, 0, 15, 78, 1, 0, 0, 0, 17, 80, 1, 0, 0, 0, 19, 82, 1, 0,
        0, 0, 21, 84, 1, 0, 0, 0, 23, 86, 1, 0, 0, 0, 25, 99, 1, 0, 0, 0, 27, 105, 1, 0, 0, 0, 29, 108, 1, 0,
        0, 0, 31, 113, 1, 0, 0, 0, 33, 127, 1, 0, 0, 0, 35, 134, 1, 0, 0, 0, 37, 154, 1, 0, 0, 0, 39, 172,
        1, 0, 0, 0, 41, 174, 1, 0, 0, 0, 43, 176, 1, 0, 0, 0, 45, 184, 1, 0, 0, 0, 47, 196, 1, 0, 0, 0, 49,
        53, 5, 34, 0, 0, 50, 52, 8, 0, 0, 0, 51, 50, 1, 0, 0, 0, 52, 55, 1, 0, 0, 0, 53, 51, 1, 0, 0, 0, 53,
        54, 1, 0, 0, 0, 54, 56, 1, 0, 0, 0, 55, 53, 1, 0, 0, 0, 56, 57, 5, 34, 0, 0, 57, 2, 1, 0, 0, 0, 58, 62,
        5, 39, 0, 0, 59, 61, 8, 1, 0, 0, 60, 59, 1, 0, 0, 0, 61, 64, 1, 0, 0, 0, 62, 60, 1, 0, 0, 0, 62, 63,
        1, 0, 0, 0, 63, 65, 1, 0, 0, 0, 64, 62, 1, 0, 0, 0, 65, 66, 5, 39, 0, 0, 66, 4, 1, 0, 0, 0, 67, 68, 5,
        123, 0, 0, 68, 6, 1, 0, 0, 0, 69, 70, 5, 95, 0, 0, 70, 71, 5, 95, 0, 0, 71, 8, 1, 0, 0, 0, 72, 73, 5,
        125, 0, 0, 73, 10, 1, 0, 0, 0, 74, 75, 5, 40, 0, 0, 75, 12, 1, 0, 0, 0, 76, 77, 5, 41, 0, 0, 77, 14,
        1, 0, 0, 0, 78, 79, 5, 42, 0, 0, 79, 16, 1, 0, 0, 0, 80, 81, 5, 94, 0, 0, 81, 18, 1, 0, 0, 0, 82, 83,
        5, 47, 0, 0, 83, 20, 1, 0, 0, 0, 84, 85, 5, 43, 0, 0, 85, 22, 1, 0, 0, 0, 86, 87, 5, 45, 0, 0, 87, 24,
        1, 0, 0, 0, 88, 100, 2, 60, 62, 0, 89, 90, 5, 61, 0, 0, 90, 100, 5, 61, 0, 0, 91, 92, 5, 60, 0, 0,
        92, 100, 5, 61, 0, 0, 93, 94, 5, 62, 0, 0, 94, 100, 5, 61, 0, 0, 95, 96, 5, 33, 0, 0, 96, 100, 5,
        61, 0, 0, 97, 98, 5, 60, 0, 0, 98, 100, 5, 62, 0, 0, 99, 88, 1, 0, 0, 0, 99, 89, 1, 0, 0, 0, 99, 91,
        1, 0, 0, 0, 99, 93, 1, 0, 0, 0, 99, 95, 1, 0, 0, 0, 99, 97, 1, 0, 0, 0, 100, 26, 1, 0, 0, 0, 101, 102,
        5, 38, 0, 0, 102, 106, 5, 38, 0, 0, 103, 104, 5, 124, 0, 0, 104, 106, 5, 124, 0, 0, 105, 101, 1,
        0, 0, 0, 105, 103, 1, 0, 0, 0, 106, 28, 1, 0, 0, 0, 107, 109, 7, 2, 0, 0, 108, 107, 1, 0, 0, 0, 109,
        110, 1, 0, 0, 0, 110, 108, 1, 0, 0, 0, 110, 111, 1, 0, 0, 0, 111, 30, 1, 0, 0, 0, 112, 114, 7, 2,
        0, 0, 113, 112, 1, 0, 0, 0, 114, 115, 1, 0, 0, 0, 115, 113, 1, 0, 0, 0, 115, 116, 1, 0, 0, 0, 116,
        117, 1, 0, 0, 0, 117, 119, 5, 46, 0, 0, 118, 120, 7, 2, 0, 0, 119, 118, 1, 0, 0, 0, 120, 121, 1,
        0, 0, 0, 121, 119, 1, 0, 0, 0, 121, 122, 1, 0, 0, 0, 122, 32, 1, 0, 0, 0, 123, 126, 3, 29, 14, 0,
        124, 126, 3, 31, 15, 0, 125, 123, 1, 0, 0, 0, 125, 124, 1, 0, 0, 0, 126, 129, 1, 0, 0, 0, 127, 125,
        1, 0, 0, 0, 127, 128, 1, 0, 0, 0, 128, 130, 1, 0, 0, 0, 129, 127, 1, 0, 0, 0, 130, 131, 5, 37, 0,
        0, 131, 34, 1, 0, 0, 0, 132, 135, 3, 1, 0, 0, 133, 135, 3, 3, 1, 0, 134, 132, 1, 0, 0, 0, 134, 133,
        1, 0, 0, 0, 135, 36, 1, 0, 0, 0, 136, 137, 5, 116, 0, 0, 137, 138, 5, 114, 0, 0, 138, 139, 5, 117,
        0, 0, 139, 155, 5, 101, 0, 0, 140, 141, 5, 84, 0, 0, 141, 142, 5, 82, 0, 0, 142, 143, 5, 85, 0,
        0, 143, 155, 5, 69, 0, 0, 144, 145, 5, 102, 0, 0, 145, 146, 5, 97, 0, 0, 146, 147, 5, 108, 0, 0,
        147, 148, 5, 115, 0, 0, 148, 155, 5, 101, 0, 0, 149, 150, 5, 70, 0, 0, 150, 151, 5, 65, 0, 0, 151,
        152, 5, 76, 0, 0, 152, 153, 5, 83, 0, 0, 153, 155, 5, 69, 0, 0, 154, 136, 1, 0, 0, 0, 154, 140,
        1, 0, 0, 0, 154, 144, 1, 0, 0, 0, 154, 149, 1, 0, 0, 0, 155, 38, 1, 0, 0, 0, 156, 158, 3, 5, 2, 0,
        157, 159, 9, 0, 0, 0, 158, 157, 1, 0, 0, 0, 159, 160, 1, 0, 0, 0, 160, 161, 1, 0, 0, 0, 160, 158,
        1, 0, 0, 0, 161, 162, 1, 0, 0, 0, 162, 163, 3, 9, 4, 0, 163, 173, 1, 0, 0, 0, 164, 166, 3, 7, 3, 0,
        165, 167, 9, 0, 0, 0, 166, 165, 1, 0, 0, 0, 167, 168, 1, 0, 0, 0, 168, 169, 1, 0, 0, 0, 168, 166,
        1, 0, 0, 0, 169, 170, 1, 0, 0, 0, 170, 171, 3, 7, 3, 0, 171, 173, 1, 0, 0, 0, 172, 156, 1, 0, 0, 0,
        172, 164, 1, 0, 0, 0, 173, 40, 1, 0, 0, 0, 174, 175, 7, 3, 0, 0, 175, 42, 1, 0, 0, 0, 176, 177, 7,
        4, 0, 0, 177, 181, 6, 21, 0, 0, 178, 180, 7, 5, 0, 0, 179, 178, 1, 0, 0, 0, 180, 183, 1, 0, 0, 0,
        181, 179, 1, 0, 0, 0, 181, 182, 1, 0, 0, 0, 182, 44, 1, 0, 0, 0, 183, 181, 1, 0, 0, 0, 184, 185,
        5, 47, 0, 0, 185, 186, 5, 47, 0, 0, 186, 190, 1, 0, 0, 0, 187, 189, 8, 6, 0, 0, 188, 187, 1, 0, 0,
        0, 189, 192, 1, 0, 0, 0, 190, 188, 1, 0, 0, 0, 190, 191, 1, 0, 0, 0, 191, 193, 1, 0, 0, 0, 192, 190,
        1, 0, 0, 0, 193, 194, 6, 22, 1, 0, 194, 46, 1, 0, 0, 0, 195, 197, 7, 7, 0, 0, 196, 195, 1, 0, 0, 0,
        197, 198, 1, 0, 0, 0, 198, 196, 1, 0, 0, 0, 198, 199, 1, 0, 0, 0, 199, 200, 1, 0, 0, 0, 200, 201,
        6, 23, 2, 0, 201, 48, 1, 0, 0, 0, 18, 0, 53, 62, 99, 105, 110, 115, 121, 125, 127, 134, 154, 160,
        168, 172, 181, 190, 198, 3, 1, 21, 0, 0, 100, 0, 6, 0, 0];
    static __ATN;
    static get _ATN() {
        if (!SplitscriptLexer.__ATN) {
            SplitscriptLexer.__ATN = new antlr4_1.ATNDeserializer().deserialize(SplitscriptLexer._serializedATN);
        }
        return SplitscriptLexer.__ATN;
    }
    static DecisionsToDFA = SplitscriptLexer._ATN.decisionToState.map((ds, index) => new antlr4_1.DFA(ds, index));
}
exports.default = SplitscriptLexer;
